module.exports = __webpack_public_path__ + "img/aygaz-conversion-club-infographic-03.d1bf16ea.jpg";